<template>
  <div
    class="d-flex align-center justify-center"
    style="height: calc(100%);"
  >
    <portal to="app-header">
      <a
        href="https://developer.mozilla.org/en-US/docs/Web/CSS/transform"
        class="mr-2"
      >
        transform | MDN
      </a>
      <a
        href="https://www.npmjs.com/package/gsap"
        class="mr-2"
      >
        gsap - npm
      </a>
    </portal>
    <div
      ref="card"
      class="card"
    >
      <img
        src="./avt.png"
        alt="图片"
      >
    </div>
  </div>
</template>

<script>

export default {
  mounted() {
    // 2. 鼠标移入事件，给card添加变量 --ry
    const card = this.$refs.card;

    const yRange = [-10, 10];
    const xRange = [-10, 10];

    function _getRotateDeg(range, position, length) {
      return range[0] + (range[1] - range[0]) * position / length
    }

    // // 注册鼠标移入事件 悬浮只会生效一次
    // card.addEventListener('mouseenter', (e) => {
    //   const { offsetWidth, offsetHeight } = card;
    //   const { offsetX, offsetY } = e
    //   console.log('鼠标移入了', offsetX, offsetWidth, offsetY, offsetHeight );

    //   const ry = _getRotateDeg(yRange, offsetX, offsetWidth);
    //   const rx = _getRotateDeg(xRange, offsetY, offsetHeight);
      
    //   card.style.setProperty('--ry', -ry + 'deg');
    //   card.style.setProperty('--rx', rx + 'deg');
      
    // })

    // 鼠标在元素内移动 悬浮效果一直会触发
    card.addEventListener('mousemove', (e) => {
      const { offsetWidth, offsetHeight } = card;
      const { offsetX, offsetY } = e
      console.log('鼠标移动了', offsetX, offsetWidth, offsetY, offsetHeight );
      const ry = _getRotateDeg(yRange, offsetX, offsetWidth);
      const rx = _getRotateDeg(xRange, offsetY, offsetHeight);
      
      card.style.setProperty('--ry', -ry + 'deg');
      card.style.setProperty('--rx', rx + 'deg');
    })


    // 注册鼠标移出事件
    card.addEventListener('mouseleave', () => {
      console.log('鼠标移出了');
      card.style.setProperty('--ry', 0);
      card.style.setProperty('--rx', 0);
    })
  },
  methods: {
  },
}
</script>

<style scoped lang="scss">
.card {
  height: 60vh;
  width: 60vh;
  img {
    height: 100%;
    box-shadow: 
    -3px -3px 10px #5c5d54,
    3px 3px 10px #5c5d54;
  }
}

.card:hover {
  // 1. 打开控制台，在card上添加变量 --ry: 10deg 鼠标移入 就可以看效果
  transform:
    perspective(500px)
    rotateY(var(--ry, 0deg))
    rotateX(var(--rx,0deg));
  transition: 0.3s;
}


</style>